import React from 'react';
import { Button, DynamicForm } from 'components';
import { Props } from 'types/modals';
import useFormHandler from 'hooks/useFormHandler';
import Base from '../../base';
import schema from './schema';

const CreationTagModal = ({ closing, onClose }: Props) => {
  const formHandler = useFormHandler(schema);

  return (
    <Base
      header="Create tag"
      closing={closing}
      onClose={onClose}
      size="md"
      footer={
        <Button
          text="Create"
          disabled={!formHandler.valid || formHandler.isSubmitting}
          onClick={() => {
            formHandler.setIsSubmitting(true);
            onClose(formHandler.data);
          }}
        />
      }
    >
      <DynamicForm handler={formHandler} />
    </Base>
  );
};

export default CreationTagModal;
